/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ConversationTypeRemoteDto {
    Unknown = 0,
    Call = 1,
    Email = 2,
    Chat = 3,
    Facebook = 4,
    Twitter = 5,
    RocketChat = 6,
}
